import { render, staticRenderFns } from "./FormControlsListItem.vue?vue&type=template&id=112b294b&scoped=true"
import script from "./FormControlsListItem.vue?vue&type=script&lang=js"
export * from "./FormControlsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b294b",
  null
  
)

export default component.exports